title: Klant|Klantenoverzicht
actions:
  sendPaymentReminder: Stuur betaalherinnering
  pauseServiceManually: Dienst handmatig pauzeren
subtitle: "{count} klant|{count} klanten"
tableHeaders:
  name: Naam
  url: Webadres
  paymentStatus: Status
  nextPaymentDate: Volgende incasso
statuses:
  all: Alle statussen
  paid: Betaald
  failed: Mislukt
  trial: Proefperiode
  canceled: Opgezegd
  pending: In afwachting
fields:
  name: Bedrijfsnaam
  slug: Webadres publieke pagina
  firstName: Voornaam
  insertions: Tussenvoegsel
  lastName: Achternaam
  email: E-mailadres
  pricePlan: Abonnement
  trialPeriodQuantity: Proefperiode (maanden)
labels:
  address: Adres
  tenantAdminUrl: Beheer omgeving
  companyInformation: Bedrijfsgegevens
  user: Hoofdgebruiker
  phoneNumber: Telefoonnummer
  email: E-mailadres
  financial: Financieel
  membershipType: Abonnementstype
  mollieCustomerId: Mollie Klant-ID
  nextPaymentDate: Volgende incasso
  subscriptionEndsAt: Platform stopt op
  subscription: Abonnement
messages:
  backToOverview: Terug naar overzicht
  lastPaymentNotification: Laatste betaalherinnering
  userAutomaticallyManaged: Deze gebruiker wordt automatisch beheerder
  informationAboutCompany: Vul de gegevens van het bedrijf in
  userReceiveEmail: Naar dit e-mailadres wordt de bevestigingsmail verstuurd met informatie voor het afgeven van de automatische incasso
  remove:
    title: Klant verwijderen
    description: Weet je zeker dat je {name} wil verwijderen? Deze actie kan niet worden ongedaan gemaakt.
    disabled: Het verwijderen van klanten is tijdelijk uitgeschakeld
